import React from 'react'
import SectionTitle from './SectionTitle'

interface SkillCategoryProps {
    title: string
    skills: string[]
}

function SkillCategory({ title, skills }: SkillCategoryProps) {
    return (
        <div className="print-avoid-break relative rounded-sm border border-line bg-panel px-4 pb-4 pt-6 transition-colors duration-150 hover:border-accent min-w-0">
            {/* Legend label — sits on the panel's top border */}
            <h3 className="pointer-events-none absolute -top-2 left-3 bg-panel px-2 font-display text-[11px] font-bold uppercase leading-4 tracking-[.22em] text-accent">
                {title}
            </h3>
            <div className="flex flex-wrap gap-1.5">
                {skills.map((skill, index) => (
                    <span
                        key={index}
                        className="border border-line bg-well px-2 py-1 font-mono text-[10.5px] text-body"
                    >
                        {skill}
                    </span>
                ))}
            </div>
        </div>
    )
}

export default function Skills() {
    const skillCategories = [
        {
            title: "AI & Agentic Systems",
            skills: [
                "Claude Code", "Agentic Development", "MCP Servers", "RAG",
                "Claude APIs", "OpenAI APIs", "AI Strategy", "AI Enablement & Adoption",
                "Semantic Layers", "Malloy"
            ]
        },
        {
            title: "Cloud & DevOps",
            skills: [
                "AWS", "Terraform", "AWS CDK", "ECS Fargate", "Lambda", "Docker",
                "CI/CD", "DevSecOps", "Datadog", "Sentry", "GuardDuty", "Tailscale",
                "Zero-Downtime Migrations", "Cost Optimization"
            ]
        },
        {
            title: "Development & Data",
            skills: [
                "TypeScript", "Python", "JavaScript", "Java", "React", "Node.js",
                "Data Engineering", "Data Lakes", "ETL/ELT", "Airflow", "Windmill",
                "Spark", "Apache Iceberg"
            ]
        },
        {
            title: "Leadership",
            skills: [
                "Engineering Management", "People Management", "Team Scaling",
                "Hiring & Interviewing", "Mentorship", "Fractional CTO",
                "Architecture Reviews", "Stakeholder Communication"
            ]
        }
    ]

    return (
        <section>
            <SectionTitle title="Skills" index="02" />
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
                {skillCategories.map((category, index) => (
                    <SkillCategory
                        key={index}
                        title={category.title}
                        skills={category.skills}
                    />
                ))}
            </div>
        </section>
    )
}
